import { createFileRoute, redirect } from "@tanstack/react-router";

// Team consolidated into Settings -> Team tab (Leo, 2026-10-01). Old links and
// bookmarks redirect so nothing 404s.
export const Route = createFileRoute("/portal/team")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/settings", search: { tab: "team" } });
  },
});
